module.exports = __webpack_public_path__ + "img/gunhualuomu.prt.df90f901.jpg";